/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react';
import Model from '@tripian/model';
import { StepCard, Svg } from '@tripian/react';
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from 'react-sortable-hoc';
import './SortableStepList.scss';

const DragHandle = SortableHandle(() => <Svg path="M10,678.2h980v-89.8H10V678.2z M10,321.8v89.8h980v-89.8H10z" viewBox="0 0 1000 1000" />);

interface ISortableStepList {
  steps: Array<Model.Step>;
  callbackSortableStepList: (sortedList: Array<number>) => void;
}

const SortableStepList: React.SFC<ISortableStepList> = ({ steps, callbackSortableStepList }) => {
  const [stepList, setStepList] = useState<Array<Model.Step>>(steps);
  const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;

  useEffect(() => {
    setStepList(steps);
  }, [steps]);

  const SortableItem = SortableElement(({ value }: any) => (
    <li className="sortable-step-list-li">
      <div className="p2">
        <StepCard
          step={value as Model.Step}
          clicked={() => {}}
          showAlternativesChange={() => {}}
          alternativeReplace={() => {}}
          alternativePois={[]}
          alternativePoisDays={[]}
          alternativePoiCardClicked={() => {}}
          isSortableStepListCard
          dragHandle={isMobileDevice ? <DragHandle /> : undefined}
        />
      </div>
    </li>
  ));

  const SortableList = SortableContainer(({ children }: any) => <ul>{children}</ul>);

  const onSortEnd = ({ oldIndex, newIndex }: any) => {
    const newList = arrayMove(stepList, oldIndex, newIndex);
    const sortedArray: Array<number> = [];
    newList.forEach((i) => {
      sortedArray.push(i.id);
    });

    setStepList(newList);

    const defaultStepList: Array<number> = [];
    steps.forEach((s) => {
      defaultStepList.push(s.id);
    });

    const isSameArray = defaultStepList.every((ds, index) => ds === sortedArray[index]);

    if (!isSameArray) {
      callbackSortableStepList(sortedArray);
    } else {
      callbackSortableStepList([]);
    }
  };

  return (
    <>
      <SortableList onSortEnd={onSortEnd} lockAxis="y" useDragHandle={isMobileDevice}>
        {stepList.map((value, index) => (
          <SortableItem key={`item-${value.id}`} index={index} value={value} />
        ))}
      </SortableList>
    </>
  );
};
export default SortableStepList;
